import { render, staticRenderFns } from "./bianxie.vue?vue&type=template&id=6801ce60&scoped=true"
import script from "./bianxie.vue?vue&type=script&lang=ts"
export * from "./bianxie.vue?vue&type=script&lang=ts"
import style0 from "./bianxie.vue?vue&type=style&index=0&id=6801ce60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6801ce60",
  null
  
)

export default component.exports